var Promise = require("promise");

var Notifications = {
	registerRemoteNotifications: noop,
	getInitialNotification: noopPromise,
	postLocalNotification: noop,
	cancelLocalNotification: noop,
	isRegisteredForRemoteNotifications: noopPromise,
	removeAllDeliveredNotifications: noop,
	ios: ios,
	events: events,
	android: android
};

function noop(){}

function noopPromise(){
	return Promise.resolve();
}

var ios = {
	requestPermissions: noop,
	checkPermissions: noop,
	abandonPermissions: noop,
	registerPushKit: noop,
	cancelAllLocalNotifications: noop,
	getDeliveredNotifications: noop,
	removeDeliveredNotifications: noop,
	getBadgeCount: noop,
	setBadgeCount: noop
};

var android = {
	refreshToken: noop
};

function events(){
	return {
		registerRemoteNotificationsRegistered: noop,
		registerNotificationReceivedForeground: noop,
		registerNotificationReceivedBackground: noop,
		registerNotificationOpened: noop,
		registerRemoteNotificationsRegistrationFailed: noop,
		registerPushKitRegistered: noop,
		registerPushKitNotificationReceived: noop
	};
}

export {Notifications};
